import styled from "@emotion/styled";
import { verticalAlignedFlexbox } from "../config/commonCSS";

// Reusable flex container that aligns the flex children centrally used mostly with text and a svg
export const FlexContainer = styled.div<{
  justifyContent?: "center" | "space-between" | "space-around" | "end";
  stretch?: boolean;
  gap?: number;
}>`
  ${verticalAlignedFlexbox};
  justify-content: ${props => props.justifyContent};
  align-self: ${props => (props.stretch ? "stretch" : "auto")};
  gap: ${props => (props.gap ? `${props.gap}px` : "unset")};
`;
